import { render, staticRenderFns } from "./CreateSharedCredential.vue?vue&type=template&id=1cc3af20&"
import script from "./CreateSharedCredential.vue?vue&type=script&lang=js&"
export * from "./CreateSharedCredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports